import React from "react";
import { Spinner } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

export const LoadingView = ({ entityType = "data" }) => (
	<div className="flex h-[300px] min-h-[40vh] w-full items-center justify-center gap-4">
		<Spinner />
		<Text>Loading {entityType} data...</Text>
	</div>
);

export const ErrorView = ({ error, entityType = "data", onNavigate }) => (
	<div className="min-h-[40vh]w-full flex h-[300px] flex-col items-center justify-center gap-4">
		<Text className="text-lg text-red-500">
			Error loading {entityType} data
		</Text>
		<Text>{error?.message || "Unknown error"}</Text>
	</div>
);

export const NoDataView = ({ entityType = "data", onNavigate }) => (
	<div className="flex h-[300px] min-h-[40vh] w-full flex-col items-center justify-center gap-4">
		<Text className="text-lg text-red-500">No {entityType} data found</Text>
	</div>
);
